import { GenericRecord, Payment } from "../../../scripts/models";
import { TableItemExtra } from "@app/components/shared/Table/Table";
import { Utils } from "@binale-tech/shared";
import { GenericRecordUtils } from "../../../scripts/models/utils/GenericRecordUtils";

export const isEmptyItem = (tableItem: TableItemExtra<Pick<GenericRecord, "key">>) => {
    if (!tableItem) {
        return true;
    }
    if (tableItem.key === null || tableItem.key === undefined) {
        return true;
    }
    if (!tableItem.item?.key) {
        return true;
    }
    return false;
};

export class TableGetters {
    static computedStatus<T extends GenericRecord>(
        tableItem: TableItemExtra<T>,
        paymentList?: Payment[]
    ): { title: string; abbr: string } {
        if (isEmptyItem(tableItem)) {
            return null;
        }
        if (!Utils.PaymentUtils.isProductPaymentSource(tableItem.item.getProductKey())) {
            return null;
        }
        let title = "Offener Posten";
        let abbr = "offen";
        paymentList = paymentList ?? tableItem.extra.payments.get(tableItem.item) ?? [];
        if (tableItem.item.getOpenBrutto(paymentList) === 0) {
            title = "bezahlt";
            abbr = "bezahlt";
        } else if (tableItem.item.avis) {
            title = "Zahlungavis";
            abbr = "AVIS";
        }
        return { title, abbr };
    }

    static computedZA<T extends GenericRecord>(tableItem: TableItemExtra<T>): { title: string; abbr: string } {
        if (isEmptyItem(tableItem)) {
            return null;
        }
        if (tableItem.item.lastschrift) {
            return { title: "Lastschrift", abbr: "LS" };
        }
        if (tableItem.extra && GenericRecordUtils.isRecordPayed(tableItem.item, tableItem.extra.payments)) {
            return null;
        }
        if (tableItem.item.avis) {
            return { title: "Avis", abbr: "A" };
        }
        return null;
    }
}
